import { render } from "./Dashboard.vue?vue&type=template&id=67173fde&bindings={}"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script